import {
  Dialog,
  DialogTitle,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
} from "@mui/material";
import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import EditReceiptsDetails from "./EditReceiptsDetails";
import EditReceiptsLinkedFmeTable from "./EditReceiptsLinkedFmeTable";
import EditReceiptsReviewTable from "./EditReceiptsReviewTable";

interface EditReceiptProps {
  open: boolean;
  handleClose: () => void;
}

const reviewTableHeadings = {
  company: "Company",
  date: "Date",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  receipt_status: "Receipt Status",
  fme: "FME",
};
const reviewTableRows = [
  {
    company: "Boyle",
    date: "26/07/25",
    receipt_number: "RC259001039",
    receipt_amount: "174.35",
    receipt_status: "Collected",
    fme: "6364",
  }
];

const tableHeadings = {
  fme: "FME",
  date: "Date",
  fme_income: "FME Income",
  policy_fme_income: "Policy FME Income",
  manual_fme_income: "Manual FME Income",
  covered: "% Covered",
  fme_status: "FME Status",
};
const rows = [
  {
    fme: "6364",
    date: "26/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    covered: "88%",
    fme_status: "Approved For Invoice",
  },
  {
    fme: "6364",
    date: "26/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    covered: "88%",
    fme_status: "Approved For Invoice",
  },
  {
    fme: "6364",
    date: "26/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    covered: "88%",
    fme_status: "Approved For Invoice",
  },
];

const EditReceiptsModal = ({ open, handleClose }: EditReceiptProps) => {
  const steps = ["Details", "Linked FME", "Review & Save"];

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      handleSave();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleSave = () => {
    console.log("Saving data...");
    alert("Data saved successfully!");
  };

  // ----------------------------
  // STEP-WISE STATIC DEMO DATA
  // ----------------------------
  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <>
            <EditReceiptsDetails />
          </>
        );

      case 1:
        return (
          <>
            <EditReceiptsLinkedFmeTable
              tableHeadings={tableHeadings}
              rows={rows}
            />
          </>
        );

      case 2:
        return (
          <>
            <EditReceiptsReviewTable
              tableHeadings={reviewTableHeadings}
              rows={reviewTableRows}
            />
          </>
        );

      default:
        return "Unknown Step";
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "1000px", maxWidth: "1000px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Edit Receipt
          </DialogTitle>

          <Box sx={{ width: "100%", mt: 2 }}>
            <Stepper
              sx={{
                "& .MuiStepIcon-root": {
                  color: "rgba(0,0,0,0.3)", // default inactive
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "secondary.main",
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "secondary.main",
                },
              }}
              activeStep={activeStep}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Step Content */}
            <Box
              sx={{
                my: 4,
                px: 1,
                minHeight: "150px",
              }}
            >
              {renderStepContent(activeStep)}
            </Box>

            {/* Buttons */}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                color="secondary"
                sx={{ mr: 1 }}
              >
                Back
              </Button>

              <Button
                color="secondary"
                variant="outlined"
                onClick={handleClose}
                sx={{ mr: 1 }}
              >
                CANCEL
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleNext}
                endIcon={
                  activeStep === steps.length - 1 ? (
                    <SaveOutlinedIcon sx={{ ml: "0.5" }} />
                  ) : (
                    <ChevronRightIcon sx={{ ml: "0.5" }} />
                  )
                }
              >
                {activeStep === steps.length - 1 ? "save changes" : "Next"}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Dialog>
    </>
  );
};

export default EditReceiptsModal;
